import { captureException } from '@sentry/react';

// ссылка на задачу https://btask.beeline.ru/browse/ES-22769
export const sendDataToWeborama = (data: WeboramaDataType) => {
  const adperftrackobj = { ...data, fullhost: 'wcm.weborama-tech.ru', site: 8935 };
  try {
    // @ts-expect-error idk
    if (window.adperfTracker) {
      // @ts-expect-error idk
      window.adperfTracker.track(adperftrackobj);
    }
  } catch (err) {
    captureException(err);
  }
};

export type WeboramaDataType = {
  conversion_page: number;
  invoice_id: string;
  client?: string;
  is_client?: boolean;
  amount?: number;
  quantity?: number;
  optional_parameters?: {
    URL?: string;
    id_product?: string;
  };
};

export const pushToWeborama = (data: WeboramaDataType) => {
  const weboramaScriptPath =
    'https://cstatic-ru-cv.weborama-tech.ru/public/js/advertiserv2/adperf_conversion.js';
  const script = document.createElement('script');
  script.setAttribute('src', weboramaScriptPath);
  script.async = true;
  document.body.appendChild(script);
  script.onload = () => sendDataToWeborama(data);
};
